export class IndexService {
    constructor(
        readonly id: number,
        readonly name: string,
        readonly url: string,
        readonly status: string,
        readonly description?: string
    ) { }
}

export enum IndexServiceStatus {

    Connected = 'connected',
    NotConnected = 'not-connected',
    ConnectedWithErros = 'connected-with-errors'

}
